import { useTranslation } from 'react-i18next';

// #89: Query-Fehler nie als Leerzustand. Karte = Hauptinhalt einer Seite.
// #108: `compact` = einzeilige Variante für Sekundär-Queries (Dialog-Innereien, Randspalten),
// wo die volle Karte das Layout erdrücken würde — gleiche Semantik (role=alert + Retry).
export function QueryErrorNotice({
  onRetry,
  className,
  compact,
}: { onRetry: () => void; className?: string; compact?: boolean }) {
  const { t } = useTranslation();
  if (compact) {
    return (
      <div
        role="alert"
        className={`flex items-center gap-2 text-xs text-text-body ${className ?? ''}`}
      >
        <span>{t('common.loadFailed.title')}</span>
        <button
          type="button"
          onClick={onRetry}
          className="font-semibold text-text-primary underline hover:no-underline"
        >
          {t('common.loadFailed.retry')}
        </button>
      </div>
    );
  }
  return (
    <div
      role="alert"
      className={`rounded-card border border-[var(--border)] bg-bg-surface p-4 text-sm ${className ?? ''}`}
    >
      <p className="font-semibold text-text-primary">{t('common.loadFailed.title')}</p>
      <p className="mt-1 text-text-body">{t('common.loadFailed.body')}</p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-3 rounded-btn border border-[var(--border)] px-3 py-1 text-sm text-text-primary hover:bg-bg-subtle"
      >
        {t('common.loadFailed.retry')}
      </button>
    </div>
  );
}
